import { PERMISSIONS } from "@/constants.js";

const getters = {
  getAccountCreation(state) {
    return state.stepsInV3.find((stepObject) => stepObject.step === "AccountCreation");
  },
  getAboutYouStep(state) {
    return state.stepsInV3.find((stepObject) => stepObject.step === "AboutYou");
  },
  getLearnerInfoStep(state) {
    return state.stepsInV3.find((stepObject) => stepObject.step === "LearnerInfo");
  },
  getReviewStep(state) {
    return state.stepsInV3.find((stepObject) => stepObject.step === "Review");
  },
  getGroupVisaStep(state) {
    return state.stepsInV3.find((stepObject) => stepObject.step === "GroupVisa");
  },
  getCheckoutStep(state) {
    return state.stepsInV3.find((stepObject) => stepObject.step === "Checkout");
  },
  getNextSteps(state) {
    return state.stepsInV3.find((stepObject) => stepObject.step === "NextSteps");
  },
  getAppliedAgreement(state) {
    return state.appliedAgreement;
  },
  getStudentFormioSubmissions(state) {
    return state.studentFormioSubmissions;
  },
  getProfileData(state) {
    return state.profileData;
  },
  getEntitiesFromProfile(state) {
    return state.profileData?.colleges?.map((college) => college.college_id) || [];
  },
  getEntitiesFromOkta(state) {
    return state.entityIDs?.map((entity) => entity.id) || [];
  },
  getEntityIds(state) {
    const oktaEntities = getters.getEntitiesFromOkta(state);
    if (oktaEntities.length > 0) {
      return oktaEntities;
    } else {
      return getters.getEntitiesFromProfile(state);
    }
  },
  getEntityIdsForTenantManager(state) {
    return getters.getEntitiesFromProfile(state);
  },
  getProgramSessionDataV3(state) {
    return state.programSessionDataV3;
  },
  getStepsInV3(state) {
    return state.stepsInV3;
  },
  getNewAccountAndApplication(state) {
    return state.newAccountAndApplication;
  },
  getPlaceDetails(state) {
    return state.placeDetails;
  },
  isLoggedIn(state) {
    return !!state.currentUser;
  },
  getPermissions(state) {
    return state.currentUser?.permissions ?? [];
  },
  getCurrentUser(state) {
    return state.currentUser;
  },
  isImpersonating(state) {
    return Boolean(state.currentUser?.impersonatedBy);
  },
  isUserEmployee(state) {
    return state.currentUser?.permissions?.includes(PERMISSIONS.API_EMPLOYEE_STUDENT_VIEW) ?? false;
  },
  currentApplication: (state) => (appId) => {
    let app = state.enrollmentApplications.find(
      (application) => Object.hasOwn(application, "application_id") && application.application_id === appId,
    );
    app = app === undefined ? [] : app;
    return app; // Gets matching application from the enrollment service
  },
  getFormioUserId: (state) => {
    return Object.hasOwn(state.userData, "_id") ? state.userData["_id"] : "";
  },
  getStudentToken: (state) => {
    return state.formioToken;
  },
  getEnrollmentToken(state) {
    return state.enrollmentToken;
  },
  getCurrentApplicationId: (state) => {
    return state.currentApplicationId;
  },
  getProgramData: (state) => {
    return state.program;
  },
  getCurrentStudentApplication: (state) => {
    const app = state.studentApplications.find(
      (application) =>
        Object.hasOwn(application, "id") && application["id"] && application["id"] === state.currentApplicationId,
    );
    return app === undefined ? null : app; // Gets matching application from form.io
  },
  getStudentType: (state) => {
    if (!Object.keys(state.userData).length) return "";
    if (!Object.hasOwn(state.userData, "data")) return "";
    if (!Object.hasOwn(state.userData.data, "student_type")) return "";
    return state.userData.data.student_type;
  },
  canSkipStep2: (state) => {
    // Edge case for applications without post_acceptance_form_rules
    // If theres no rules, the section does not need to be completed
    let skipSection = true;
    if (Object.hasOwn(state.onboardingStep2Forms, "forms")) {
      const completed = state.onboardingStep2Forms.forms.filter((form) => form.submitted);
      skipSection = completed.length === state.onboardingStep2Forms.forms.length;
    }
    return skipSection;
  },
  getSessionExpired: (state) => {
    return state.sessionExpired;
  },
  getRedirectPath: (state) => {
    const redirectPath = localStorage.getItem("redirectPath") ? localStorage.getItem("redirectPath") : "";

    if (state.redirectPath) return state.redirectPath;
    else return redirectPath;
  },
  getProgramFromCurrentOrder(state) {
    return state.currentOrder?.program ?? {};
  },
  getRedirectSessionData(state) {
    return state.redirectSessionData;
  },
  getBrandingDetails(state) {
    return state.brandingDetails;
  },
  getDomainEntityId(state) {
    //this will always return a value, see VerifySubdomain.php and the main blade pages for details
    return state.domainEntityId;
  },
  getEntityApiRelationship(state) {
    return state.currentAPIRelationship;
  },
  getFeatureFlags(state) {
    return state.featureFlags;
  },
  getBooleanFeatureFlag: (state) => (flagName) => {
    return !!state.featureFlags?.[flagName];
  },
  getCurrentApplicationSubmissions: (state) => (formName) => {
    return state.currentApplicationSubmissions?.[formName];
  },
  getAnonToken(state) {
    return state.anonToken;
  },
};
export default getters;
